import i18n, { i18nMergeMessage } from "@/i18n.js";
import { to } from "await-to-js";
import apiList from "@/api/apiList.js";
import { webSocket, clearTimer } from "@/utils/wsUtils.js";
import { Notification } from "element-ui";
import { isEmpty } from "@/utils/utils";
import actions from "@/store/shardActions.js";
// import { i18n } from "element-ui/lib/locale";

export default {
  namespaced: true,
  state: {
    languageList: window.HS_CONFIG.languageList || [],
    // 数据变化标志
    dataUpdate: "",
    // 默认关闭，用户退出时设置为关闭
    hasServicePage: false,
    // 只要有as的权限，就可以进入 用户密码修改界面
    hasAsPermission: false,
    //需要根据as权限处理插件是否显示
    asPermissionTree: [],
    // 收件箱详情
    inboxDetailDialog: {
      show: false,
      id: "",
      content: "",
    },
    // license信息
    inboxStatus: "first",
    licenseUpdate: false,
    noShowTips: localStorage.getItem("noShowTips")
      ? JSON.parse(localStorage.getItem("noShowTips"))
      : false, // 默认显示license的提示信息
    userInfo: {},
    apps: [],
    plugins: [],
    manageApps:[]
  },
  mutations: {
    updateLanguageList(state, langs = []) {
      state.languageList = langs;
    },
    // updateLanguageData(state) {
    //   state.languageData =
    //     JSON.parse(localStorage.getItem("as-languageData")) ?? [];
    //   state.languageData.forEach((item) => {
    //     i18n.setLocaleMessage(
    //       item.i18n,
    //       i18nMergeElemI18n(item.i18n, item.data.base)
    //     );
    //   });
    // },
    dataUpdate(state, payload) {
      state.dataUpdate = payload;
    },
    hasServicePage(state, payload) {
      state.hasServicePage = payload;
    },
    hasAsPermission(state, payload) {
      state.hasAsPermission = payload;
    },
    setAsPermissionTree(state, payload) {
      state.asPermissionTree = payload;
    },
    changeInboxDetailDialog(state, payload) {
      state.inboxDetailDialog = payload;
    },
    changeInboxStatus(state, payload) {
      state.inboxStatus = payload;
    },
    licenseUpdate(state, payload) {
      state.licenseUpdate = payload;
    },
    changeTipsStatus(state, payload) {
      state.noShowTips = payload;
      localStorage.setItem("noShowTips", JSON.stringify(payload));
    },
    setUserInfo(state, payload = {}) {
      state.userInfo = payload;
    },
    setApps(state, payload = []) {
      state.apps = payload;
    },
    setPlugins(state, payload = []) {
      state.plugins = payload;
    },
    setManageApps(state,payload=[]){
      state.manageApps=payload
    }
  },
  actions: {
    async getLangList({ commit, state }) {
      let languageList = [];
      const [err, res] = await to(apiList.getConfigByName("systemI18n"));
      if (err) {
        return;
      }
      if (res.resultCode == 1001 && res.data?.value) {
        languageList = res.data.value;
        const obj = {};
        languageList.forEach((lang) => {
          obj[lang.code] = lang.name;
        });
        const allLang = Object.keys(obj).map((key) => {
          return {
            name: obj[key],
            code: key,
          };
        });
        commit("updateLanguageList", allLang);
      }
    },

    async getLangData() {
      const [langErr, langData] = await to(apiList.getLanguageList());
      if (langErr) {
        return;
      }
      if (langData.data) {
        const mergeMessage = {};
        langData.data.forEach((item) => {
          mergeMessage[item.i18n] = item.data.base;
        });
        i18nMergeMessage(mergeMessage);
      }
    },

    async readMessage({ state, commit }, payload) {
      if (state.inboxDetailDialog.show) {
        Notification.warning(i18n.t("messageBoxPromptMessage.inReading"));
        return;
      }
      const [err, res] = await to(apiList.getMessageDetails(payload.id), {
        language: actions.getGlobalState("currentLanguage"),
      });
      if (err) {
        return;
      }
      if (res.resultCode == 1001) {
        commit("changeInboxDetailDialog", {
          show: true,
          id: payload.id,
          content: res.data,
        });
      }
    },

    logout({ commit }) {
      if (!isEmpty(webSocket)) {
        try {
          webSocket.close();
        } finally {
          clearTimer();
        }
      }
      commit("changeTipsStatus", false);
      actions.setGlobalState({
        logout: true,
      });
    },
  },
};
